module.exports = function noop() {};
